import { Alert, Button } from '@efexteam/components';
import { useRole } from '@efexteam/permission-manager';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import DetailView from '../components/DetailView';

interface SuccessProps {
  close: () => void;
  newPayment: () => void;
  isSchedule?: boolean;
}

const Success = ({ close, newPayment, isSchedule }: SuccessProps) => {
  const { t } = useTranslation();
  const { isPaymentAnalyst } = useRole();

  return (
    <Grid container>
      <Grid item xs={12} className="!mb-5 text-center">
        <CheckCircleIcon
          sx={{ color: '#4db6ac', fontSize: '60px', margin: '0 auto' }}
        />
        {!isPaymentAnalyst && (
          <Typography variant="h6" className="!my-4 !text-center">
            {t(isSchedule ? 'schedulePaymentInProgress' : 'paymentSuccess')}
          </Typography>
        )}
        {isPaymentAnalyst && (
          <Typography variant="h6" className="!my-4 !text-center">
            {t(isSchedule ? 'schedulePaymentAnalyst' : 'paymentSuccessAnalyst')}
          </Typography>
        )}
      </Grid>
      {isPaymentAnalyst && (
        <Alert severity="info" className="mb-5">
          {t('paymentSuccessAnalystMessage')}
        </Alert>
      )}
      <DetailView isSuccessDetail />
      <Grid
        item
        xs={12}
        className="flex !flex-col md:!flex-row justify-around gap-4"
      >
        <Button
          appearance="secondary"
          size="large"
          className="mt-4"
          onClick={close}
        >
          {t('close')}
        </Button>
        <Button
          appearance="primary"
          size="large"
          className="mt-4"
          onClick={newPayment}
        >
          {t(isPaymentAnalyst ? 'configureNewTransfer' : 'newPayment')}
        </Button>
      </Grid>
    </Grid>
  );
};

export default Success;
